/* ==========================================================================
   BodenWerk – Bildergalerie auf der Produktseite

   Eine Buehne, darunter die Vorschaureihe. Alle Bilder liegen bereits im
   Markup uebereinander; hier wird nur umgeschaltet, damit ohne JavaScript das
   erste Bild steht und die Vorschauen als Links auf die Originale wirken.
   ========================================================================== */
(function () {
  'use strict';

  function initGalerie(wurzel) {
    if (!wurzel || wurzel.__bwGalerieInit) return;
    wurzel.__bwGalerieInit = true;

    var bilder = wurzel.querySelectorAll('[data-bw-galerie-bild]');
    var knoepfe = wurzel.querySelectorAll('[data-bw-galerie-wahl]');
    if (bilder.length < 2 || knoepfe.length !== bilder.length) return;

    var aktuell = 0;

    function zeige(i) {
      aktuell = i;
      for (var k = 0; k < bilder.length; k++) {
        var an = k === i;
        bilder[k].classList.toggle('is-aktiv', an);
        knoepfe[k].classList.toggle('is-aktiv', an);
        knoepfe[k].setAttribute('aria-current', an ? 'true' : 'false');
      }
    }

    for (var k = 0; k < knoepfe.length; k++) {
      (function (i) {
        knoepfe[i].addEventListener('click', function (e) {
          e.preventDefault(); // ohne JS bliebe der Link auf die Originaldatei
          zeige(i);
          // Frage: Braucht es mehr Bilder je Produkt?
          if (window.bwEreignis) {
            window.bwEreignis.melde('bw_galerie_wechsel', { ansicht: i + 1, ansichten_gesamt: knoepfe.length });
          }
        });
        // Pfeiltasten innerhalb der Reihe
        knoepfe[i].addEventListener('keydown', function (e) {
          var ziel = null;
          if (e.key === 'ArrowRight') ziel = (i + 1) % knoepfe.length;
          if (e.key === 'ArrowLeft') ziel = (i - 1 + knoepfe.length) % knoepfe.length;
          if (ziel === null) return;
          e.preventDefault();
          zeige(ziel);
          knoepfe[ziel].focus();
        });
      })(k);
    }

    // Wischen auf der Buehne (Handy): links/rechts zur naechsten Ansicht
    var buehne = wurzel.querySelector('.bw-pdp__buehne');
    if (buehne) {
      var startX = null;
      var startY = null;
      buehne.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      buehne.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var ziel = (aktuell + (dx < 0 ? 1 : -1) + bilder.length) % bilder.length;
        zeige(ziel);
      }, { passive: true });
    }

    zeige(0);
  }

  function initAll() {
    var knoten = document.querySelectorAll('[data-bw-galerie]');
    for (var i = 0; i < knoten.length; i++) initGalerie(knoten[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
